import { Badge, Box, IconButton, Tooltip } from "@material-ui/core";
import { ClearOutlined, FilterListOutlined } from "@material-ui/icons";
import locale from "@bonliva-crm/locale";
import { useTravelRequestSearchFilters } from "../hooks/use-travel-request-search-filters";
import { SortFilter } from "@bonliva-crm/ui/search-filters";

export function TravelRequestTopBar() {
  const {
    hasValues,
    filterManager: { setFilterSliderOpen, resetFilters }
  } = useTravelRequestSearchFilters();

  const sortOptions = [
    {
      value: "createdOn_asc",
      label: locale.asc(locale.Created)
    },
    {
      value: "createdOn_desc",
      label: locale.desc(locale.Created)
    },
    {
      value: "departureDate_asc",
      label: locale.asc(locale.DepartureDate)
    },
    {
      value: "departureDate_desc",
      label: locale.desc(locale.DepartureDate)
    }
  ];

  return (
    <>
      <Box style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
        <Tooltip title={locale.AllFilters}>
          <IconButton onClick={() => setFilterSliderOpen(true)}>
            <Badge color="primary" variant="dot" invisible={!hasValues}>
              <FilterListOutlined />
            </Badge>
          </IconButton>
        </Tooltip>

        <Tooltip title={locale.resetFilters}>
          <IconButton onClick={resetFilters}>
            <ClearOutlined />
          </IconButton>
        </Tooltip>

        <SortFilter name={"sort"} options={sortOptions} />
      </Box>
    </>
  );
}
